var spiceCloseQuickAdd = new Event('spice.CloseQuickADD');

//// ajax cart events 

var spiceCartOpen = new Event('spiceCart.open');
var spiceCartClose = new Event('spiceCart.close');


window.addEventListener('spiceCart.open', function (e) {
    document.querySelector('#cart-toggle').click();
}, false);


window.addEventListener('spiceCart.close', function (e) {
    document.querySelector('#cart-close').click();
}, false);